import get from 'lodash/get';

import { getLinkHref } from 'shared/helpers/uri';

export default (page: object) => {
  const logoutLink = get(page, 'authentication.logoutLink');

  return logoutLink && getLinkHref(logoutLink);
};
